  /* jshint esversion: 8 */
define([
  "dojo/i18n!nls/cloudCenterStringResource",
  "util",
  "service/datatransform/ruleInfo"
], function(I18NStringResource, Util, RuleInfo) {

  class ReleaseInfo {

    constructor(rule) {
      this.product = rule.product;
      this.release = rule.release;
      this.description = rule.description;
      this.providers = {};
      if (rule.eol) {
        this.status = RuleInfo._EOLStatusValues[rule.eol.Status];
        this.sunsetOnDate = Util.formatDateYMD(new Date(rule.eol.SunsetOnDate.seconds * 1000));
      } else {
        this.status = RuleInfo.StatusIntActive;
        this.sunsetOnDate = "";
      }
      if (rule.cloudPlatform && rule.os) {
        this.add(rule.cloudPlatform, rule.os);
      }
    }

    add(provider, os) {
      if (provider && os) {
        if (this.providers[provider]) {
          const p = this.providers[provider];
          /* istanbul ignore next */
          if (!p.osList) {
            p.osList = [];
          }
          if (!p.osList.includes(os)) {
            p.osList.push(os);
            p.osList = p.osList.sort();
          }
        } else {
          this.providers[provider] = { osList: [os] };
        }
      }
    }

    getProviders() {
      return this.providers;
    }

    static fromAvailableType(entry) {
      const now = Date.now();
      let status = RuleInfo.StatusIntActive;
      let sunsetOnDate = "";
      if (entry.sunset_date) {
        const sunsetMs = new Date(entry.sunset_date).getTime();
        if (sunsetMs <= now) {
          status = RuleInfo.StatusIntSunsetted;
        } else if (entry.deprecate_date && new Date(entry.deprecate_date).getTime() <= now) {
          status = RuleInfo.StatusIntDeprecated;
        }
        sunsetOnDate = entry.sunset_date;
      } else if (entry.deprecate_date && new Date(entry.deprecate_date).getTime() <= now) {
        status = RuleInfo.StatusIntDeprecated;
        sunsetOnDate = "";
      }
      const ri = new ReleaseInfo({
        product: entry.product,
        release: entry.version,
        description: entry.description,
        eol: null
      });
      ri.status = status;
      ri.sunsetOnDate = sunsetOnDate;
      if (entry.cloud_provider && entry.operating_system) {
        ri.add(entry.cloud_provider, entry.operating_system);
      }
      return ri;
    }

  }

  return ReleaseInfo;
}); // require
